import { RouteRecordRaw } from "vue-router";
import { accessGuard, GetServiceName, initGuard, LoginGuard } from "./accessGuard";
import { adminRessourceGuard, ressourceGuard } from "./resourceGuard";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/samsungfire',
    children: [
      {
        path: 'obesity',
        name: 'samsungfire-obesity',
        component: () => import(/* webpackChunkName: "MainView" */ '@samsungfireObesity/views/MainView.vue'),
        beforeEnter: [ GetServiceName, accessGuard, ressourceGuard ],
        children: [
          {
            path: 'agree',
            name: 'agree',
            component: () => import(/* webpackChunkName: "Agree" */ '@samsungfireObesity/components/organisms/scraping/Agree.vue'),
            beforeEnter: [ initGuard, accessGuard]
          },
          {
            path: 'method',
            name: 'method',
            component: () => import(/* webpackChunkName: "Method" */ '@samsungfireObesity/components/organisms/scraping/Method.vue'),
            beforeEnter: accessGuard
          },
          {
            path: 'request',
            name: 'request',
            component: () => import(/* webpackChunkName: "Request" */ '@samsungfireObesity/components/organisms/scraping/Request.vue'),
            beforeEnter: accessGuard
          },
          {
            path: 'confirm',
            name: 'confirm',
            component: () => import(/* webpackChunkName: "Confirm" */ '@samsungfireObesity/components/organisms/scraping/Confirm.vue'),
            beforeEnter: accessGuard
          },
          {
            path: ':code',
            name: 'result',
            component: () => import(/* webpackChunkName: "Result" */ '@samsungfireObesity/components/organisms/scraping/Result.vue'),
            beforeEnter: accessGuard
          },
        ]
      },
      {
        path: 'admCritical',
        name: 'samsungfire-admCritical',
        component: () => import(/* webpackChunkName: "MainView" */ '@samsungfireObesity/views/MainView.vue'),
        beforeEnter: [ GetServiceName, accessGuard, ressourceGuard ],
        children: [
          {
            path: 'agree',
            name: 'agree-admCritical',
            component: () => import(/* webpackChunkName: "Agree" */ '@samsungfireObesity/components/organisms/scraping/Agree.vue'),
            beforeEnter: [ initGuard, accessGuard]
          },
          {
            path: 'method',
            name: 'method-admCritical',
            component: () => import(/* webpackChunkName: "Method" */ '@samsungfireObesity/components/organisms/scraping/Method.vue'),
            beforeEnter: accessGuard
          },
          {
            path: 'request',
            name: 'request-admCritical',
            component: () => import(/* webpackChunkName: "Request" */ '@samsungfireObesity/components/organisms/scraping/Request.vue'),
            beforeEnter: accessGuard
          },
          {
            path: 'confirm',
            name: 'confirm-admCritical',
            component: () => import(/* webpackChunkName: "Confirm" */ '@samsungfireObesity/components/organisms/scraping/Confirm.vue'),
            beforeEnter: accessGuard
          },
          {
            path: ':code',
            name: 'result-admCritical',
            component: () => import(/* webpackChunkName: "Result" */ '@samsungfireObesity/components/organisms/scraping/Result.vue'),
            beforeEnter: accessGuard
          },
        ]
      },
      {
        path: 'admin',
        name: 'samsungfire-admin',
        component: () => import(/* webpackChunkName: "AdminView" */ '@samsungfireObesity/views/AdminView.vue'),
        beforeEnter: [ adminRessourceGuard ],
        children: [
          {
            path: 'login',
            name: 'login',
            beforeEnter: [ LoginGuard ],
            component: () => import(/* webpackChunkName: "Login" */ '@samsungfireObesity/components/organisms/admin/Login.vue')
          },
          {
            path: 'list',
            name: 'list',
            beforeEnter: [ LoginGuard ],
            component: () => import(/* webpackChunkName: "List" */ '@samsungfireObesity/components/organisms/admin/List.vue')
          }
        ]
      }
    ]
  }
];

export default routes;